import { Popup } from '@whitesharx/starfall-frontend-ui-kit';
import { popupStyles, popupContentStyles } from './styles.css';

export const createPopup = (
  title: string,
  element: HTMLElement,
  arrowPlacement: 'top' | 'right' | 'bottom' | 'left',
  isDesktop = true
) => {
  const rect = element.getBoundingClientRect();

  let style;
  if (arrowPlacement === 'top') {
    style = {
      height: isDesktop ? rect.height + 12 : rect.height + 6,
      top: isDesktop ? rect.top + rect.height + 20 : rect.top + rect.height,
      left: isDesktop ? rect.left : rect.left + 20,
    };
  }
  if (arrowPlacement === 'right') {
    style = {
      height: rect.height + 32,
      top: rect.top - 16,
      left: rect.left - rect.width - 30,
    };
  }
  if (arrowPlacement === 'bottom') {
    style = {
      height: rect.height,
      top: rect.top - rect.height - 20,
      left: rect.left,
      width: rect.width,
    };
  }
  if (arrowPlacement === 'left') {
    style = {
      height: rect.height + 32,
      top: rect.top - 16,
      left: rect.right,
    };
  }

  return (
    <Popup
      style={style}
      content={title}
      containerClassName={popupStyles}
      contentClassName={popupContentStyles}
      background="pink"
      arrowPlacement={arrowPlacement}
    />
  );
};
